import { useState } from "react";
import { assistantReplies } from "../data/assistantScript";
import type { AssistantLink, AssistantTopic } from "../data/assistantScript";

export type ChatMessage = { id: number; from: "user" | "assistant"; text: string; links?: AssistantLink[] };

const intro: ChatMessage = {
  id: 0,
  from: "assistant",
  text: "Hi, I’m Ask Oceanside, an AI assistant (scripted demonstration). I can point you to designs, the building process and ways to contact the team. I can’t give prices, timeframes or site advice.",
};

function matchTopic(text: string): AssistantTopic {
  const value = text.toLowerCase();
  if (/(price|cost|\$|budget|quote|how much)/.test(value)) return "pricing";
  if (/(design|bedroom|frontage|solene|cortez|azure|hacienda|plan)/.test(value)) return "design";
  if (/(process|step|stage|agreement|handover|how does)/.test(value)) return "process";
  if (/(block|site|lot|rebuild|knock|rear|develop)/.test(value)) return "block";
  if (/(consult|meet|talk|book|appointment|contact|call)/.test(value)) return "consult";
  return "fallback";
}

export function useAskOceanside() {
  const [messages, setMessages] = useState<ChatMessage[]>([intro]);

  const respond = (userText: string, topic: AssistantTopic) => {
    const reply = assistantReplies[topic];
    setMessages((current) => [
      ...current,
      { id: current.length, from: "user", text: userText },
      { id: current.length + 1, from: "assistant", text: reply.text, links: reply.links },
    ]);
  };

  const ask = (text: string) => {
    const trimmed = text.trim();
    if (!trimmed) return;
    respond(trimmed, matchTopic(trimmed));
  };

  const choose = (topic: AssistantTopic, label: string) => respond(label, topic);

  const reset = () => setMessages([intro]);

  return { messages, ask, choose, reset };
}
